import { PageComponent } from "barba"

class Segmented {
    constructor({ node, container }) {
        this.node = node
        this.anchors = [...this.node.querySelectorAll('.segmented__link[href^="#"]')]
        this.sections = container.querySelectorAll(this.anchors.map(x => x.getAttribute('href')).join(','))
        
        this.intersectionObserver = new IntersectionObserver(
            (entries) => {
                for (let i = entries.length - 1; i >= 0; i--) {
                    if (entries[i].isIntersecting) {
                        this.active(entries[i].target.id)
                        return
                    }
                }
            },
            {
                rootMargin: "-50% 0px -50% 0px"
            }
        )
        
        this.sections.forEach(x => {
            this.intersectionObserver.observe(x)
        })
    }

    active(id = null) {
        if (!id) return
        const c = 'segmented__link--active'
        this.anchors.forEach(x => x.classList.remove(c))
        this.node.querySelector(`.segmented__link[href="#${id}"]`).classList.add(c)
    }

    destroy() {
        this.intersectionObserver.disconnect()

        delete this.node
        delete this.anchors
        delete this.sections
        delete this.intersectionObserver
    }
}

new PageComponent(".segmented", Segmented)
